import { createSlice } from "@reduxjs/toolkit";
import { loadAssets } from "./assetsSlice";
import { loadSounds } from "./soundsSlice";

// Import universal initializeGame action
import { initializeGame } from "./gameSettingsSlice";

const loadingProgressSlice = createSlice({
  name: "loadingProgress",
  initialState: {
    status: "idle", // idle, loading, success, error
    loaderComplete: false, // true after loader "out" animation finishes
  },
  reducers: {
    setLoaderComplete: (state) => {
      state.loaderComplete = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadAssets.pending, (state) => {
        if (state.status === "idle") {
          state.status = "loading";
        }
      })
      .addCase(loadAssets.rejected, (state) => {
        state.status = "error";
      })
      .addCase(loadSounds.rejected, (state) => {
        state.status = "error";
      })
      .addCase(initializeGame.fulfilled, (state) => {
        state.status = "success";
      })
      .addCase(initializeGame.rejected, (state) => {
        state.status = "error";
      });
  },
});

export const { setLoaderComplete } = loadingProgressSlice.actions;
export default loadingProgressSlice.reducer;
